import React from "react";
import styles from "./FestiveSection.module.css";

const dataCards = [
  {
    title: "Sarhul Celebration",
    description:
      "Experience the vibrant tribal New Year marked by nature worship, traditional dances, and community joy.",
    image: "/images/Sarhul/sarhul1.jpg",
  },
  {
    title: "Sacred Grove Rituals",
    description:
      "Witness the offering of sal flowers to Mother Earth, symbolizing gratitude and a bountiful year ahead.",
    image: "/images/Sarhul/sarhul2.jpg",
  },
  {
    title: "Cultural Gathering",
    description:
      "Join in the rhythmic tribal dances, music, and celebrations that echo the spirit of Sarhul.",
    image: "/images/Sarhul/sarhul3.jpg",
  },
];

const DataCard = ({ title, description, image }) => (
  <div className={styles.card} style={{ backgroundImage: `url(${image})` }}>
    <div className={styles.overlay}></div>
    <div className={styles.cardContent}>
      <h3 className={styles.cardTitle}>{title}</h3>
      <p className={styles.cardDescription}>{description}</p>
    </div>
  </div>
);

const FestiveSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Sarhul Festival</h2>
      </div>

      <div className={styles.cardsContainer}>
        {dataCards.map((card, index) => (
          <DataCard key={index} {...card} />
        ))}
      </div>
      <p className={styles.description}>
        The "Sarhul Khele Chal" festival at Bhagwan Birsa Munda Museum, Ranchi,
        beautifully showcases Jharkhand's tribal identity through folk music,
        dances, and cultural displays. This two-day extravaganza features
        traditional Jharkhandi cuisine stalls, exquisite local handicrafts,
        premium Tussar silk exhibitions, and mesmerizing Sohrai & Paitkar tribal
        paintings. The air resonates with rhythmic folk performances, creating a
        colorful celebration of indigenous traditions. Visitors immerse
        themselves in authentic tribal culture, making it a must-experience
        cultural rendezvous that truly honors Jharkhand's rich heritage.
      </p>
    </section>
  );
};

export default FestiveSection;
